import { configureStore } from "@reduxjs/toolkit";
import verificationReducer from "@/features/verifyWorkEmail/store/verificationSlice";
import verifiedReducer from "@/features/verified/store/verifiedSlice";
import welcomeReducer from "@/features/signIn/store/welcomeSlice";
import globalReducer from "@/store/globalSlice";

export const store = configureStore({
  reducer: {
    welcome: welcomeReducer,
    verified: verifiedReducer,
    verification: verificationReducer,
    global: globalReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
